export class Tooltip {
    constructor() {
        if ($.fn.tooltip) {
            $('[data-bs-toggle="tooltip"]').tooltip();
        }
    }
}
